
{
  "familyId": "GET-HOOFDREKENEN",
  "questions": [
    {
      "id": "GET-HOOFDREKENEN-001",
      "familyId": "GET-HOOFDREKENEN",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "bewerkingen",
      "subSkill": "hoofdrekenen_strategieen",
      "questionType": "multiple_choice",
      "question": "Reken handig uit: 48 + 37",
      "context": null,
      "options": ["85", "75", "95", "84"],
      "correctAnswer": 0,
      "conceptId": "mental_math_addition",
      "variantIndex": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Handig optellen",
            "content": "Strategie: splits in tientallen en eenheden. 48 + 37 = (40 + 30) + (8 + 7) = 70 + 15 = 85. Of: 48 + 37 = 48 + 2 + 35 = 50 + 35 = 85."
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is 85. Strategie 1: splits in tientallen en eenheden. 48 + 37 = (40 + 30) + (8 + 7) = 70 + 15 = 85. Strategie 2: maak een rond getal. 48 + 2 = 50, dan 50 + 35 = 85.",
        "distractorExplanations": {
          "0": "Goed! 48 + 37 = 85. Bijvoorbeeld: 40 + 30 = 70, en 8 + 7 = 15, samen 70 + 15 = 85.",
          "1": "75 is fout. Je hebt misschien 40 + 30 = 70 berekend en de eenheden vergeten (8 + 7 = 15). 70 + 15 = 85, niet 75.",
          "2": "95 is fout. Je hebt misschien 50 + 40 = 90 berekend (beide getallen naar boven afgerond). Reken exact: 48 + 37 = 85.",
          "3": "84 is fout. Je hebt misschien 8 + 7 = 14 berekend in plaats van 15. Controleer: 8 + 7 = 15. Dus 70 + 15 = 85."
        }
      }
    },
    {
      "id": "GET-HOOFDREKENEN-002",
      "familyId": "GET-HOOFDREKENEN",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "bewerkingen",
      "subSkill": "hoofdrekenen_strategieen",
      "questionType": "multiple_choice",
      "question": "Reken handig uit: 63 - 28",
      "context": null,
      "options": ["35", "45", "25", "31"],
      "correctAnswer": 0,
      "conceptId": "mental_math_subtraction",
      "variantIndex": 2,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Handig aftrekken",
            "content": "Strategie: trek eerst een rond getal af, tel dan het verschil terug. 63 - 28 = 63 - 30 + 2 = 33 + 2 = 35. Of: 63 - 28 = (63 - 20) - 8 = 43 - 8 = 35."
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is 35. Strategie 1: trek een rond getal af. 63 - 30 = 33, dan 33 + 2 = 35 (je hebt 2 te veel afgetrokken). Strategie 2: stapsgewijs. 63 - 20 = 43, dan 43 - 8 = 35.",
        "distractorExplanations": {
          "0": "Goed! 63 - 28 = 35. Bijvoorbeeld: 63 - 30 = 33, dan 33 + 2 = 35.",
          "1": "45 is fout. Je hebt misschien 63 - 20 = 43 berekend en dan 43 + 2 = 45. Maar je moet nog 8 aftrekken, niet 2 optellen: 43 - 8 = 35.",
          "2": "25 is fout. Je hebt misschien 63 - 38 = 25 berekend (28 verward met 38). Controleer: 63 - 28 = 35.",
          "3": "31 is fout. Je hebt misschien 63 - 32 = 31 berekend. Controleer het aftrekgetal: het is 28, niet 32. 63 - 28 = 35."
        }
      }
    },
    {
      "id": "GET-HOOFDREKENEN-003",
      "familyId": "GET-HOOFDREKENEN",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "bewerkingen",
      "subSkill": "hoofdrekenen_strategieen",
      "questionType": "multiple_choice",
      "question": "Reken handig uit: 4 × 25",
      "context": null,
      "options": ["100", "75", "125", "80"],
      "correctAnswer": 0,
      "conceptId": "mental_math_multiplication",
      "variantIndex": 3,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Handig vermenigvuldigen",
            "content": "Onthoud: 4 × 25 = 100. Dit is een standaard rekentruc. 25 = een kwart van 100, dus 4 × 25 = 4 × (100 ÷ 4) = 100."
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is 100. Strategie: 25 is een kwart van 100. Dus 4 × 25 = 100. Of stapsgewijs: 4 × 25 = 4 × 20 + 4 × 5 = 80 + 20 = 100.",
        "distractorExplanations": {
          "0": "Goed! 4 × 25 = 100. Onthoud: 4 kwartjes = 1 euro (100 cent).",
          "1": "75 is fout. Je hebt misschien 3 × 25 = 75 berekend. Maar je vermenigvuldigt met 4, niet 3: 4 × 25 = 100.",
          "2": "125 is fout. Je hebt misschien 5 × 25 = 125 berekend. Maar je vermenigvuldigt met 4, niet 5: 4 × 25 = 100.",
          "3": "80 is fout. Je hebt misschien 4 × 20 = 80 berekend en de 4 × 5 = 20 vergeten. 80 + 20 = 100."
        }
      }
    },
    {
      "id": "GET-HOOFDREKENEN-004",
      "familyId": "GET-HOOFDREKENEN",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "bewerkingen",
      "subSkill": "hoofdrekenen_strategieen",
      "questionType": "multiple_choice",
      "question": "Reken handig uit: 99 + 56",
      "context": null,
      "options": ["155", "145", "165", "154"],
      "correctAnswer": 0,
      "conceptId": "mental_math_near_hundred",
      "variantIndex": 4,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Optellen bij bijna-ronde getallen",
            "content": "Strategie: 99 is bijna 100. Reken: 100 + 56 = 156, dan 156 - 1 = 155. Je hebt 1 te veel opgeteld, dus trek 1 af."
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is 155. Strategie: 99 is bijna 100. Stap 1: 100 + 56 = 156. Stap 2: je hebt 1 te veel opgeteld (99, niet 100), dus trek 1 af: 156 - 1 = 155.",
        "distractorExplanations": {
          "0": "Goed! 99 + 56 = 100 + 56 - 1 = 156 - 1 = 155.",
          "1": "145 is fout. Je hebt misschien 90 + 56 = 146 of een andere fout gemaakt. Gebruik de strategie: 100 + 56 = 156, dan 156 - 1 = 155.",
          "2": "165 is fout. Je hebt misschien 100 + 56 = 156 berekend en dan 10 extra opgeteld. Trek juist 1 af: 156 - 1 = 155.",
          "3": "154 is fout. Je hebt misschien 100 + 56 = 156 berekend en dan 2 afgetrokken in plaats van 1. Trek slechts 1 af (want 99 = 100 - 1): 156 - 1 = 155."
        }
      }
    },
    {
      "id": "GET-HOOFDREKENEN-005",
      "familyId": "GET-HOOFDREKENEN",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "bewerkingen",
      "subSkill": "hoofdrekenen_strategieen",
      "questionType": "multiple_choice",
      "question": "Reken handig uit: 8 × 15",
      "context": null,
      "options": ["120", "80", "115", "130"],
      "correctAnswer": 0,
      "conceptId": "mental_math_split_multiply",
      "variantIndex": 5,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Handig vermenigvuldigen: splitsen",
            "content": "Strategie: splits 15 in 10 + 5. Dan: 8 × 10 = 80 en 8 × 5 = 40. Samen: 80 + 40 = 120. Of: 8 × 15 = 4 × 30 = 120."
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is 120. Strategie 1: splits 15 = 10 + 5. Dan: 8 × 10 = 80 en 8 × 5 = 40. Samen: 80 + 40 = 120. Strategie 2: verdubbel en halveer. 8 × 15 = 4 × 30 = 120.",
        "distractorExplanations": {
          "0": "Goed! 8 × 15 = 120. Bijvoorbeeld: 8 × 10 = 80 en 8 × 5 = 40, samen 120.",
          "1": "80 is fout. Je hebt alleen 8 × 10 = 80 berekend en de 8 × 5 = 40 vergeten. 80 + 40 = 120.",
          "2": "115 is fout. Controleer je berekening: 8 × 15 = 8 × 10 + 8 × 5 = 80 + 40 = 120, niet 115.",
          "3": "130 is fout. Je hebt misschien 8 × 10 = 80 en 8 × 5 = 50 berekend (5 × 10 = 50 in plaats van 8 × 5 = 40). Controleer: 8 × 5 = 40, dus 80 + 40 = 120."
        }
      }
    }
  ]
}
